import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import { getProductBySku } from './productLookupHelper';
import type { ProductComplete, ProductSelection } from '../types/models';

export const baseSkuCandidates = (sku: string): string[] => {
  const segments = sku.split('-');
  const candidates: string[] = [];
  for (let length = segments.length - 1; length > 0; length--) {
    candidates.push(segments.slice(0, length).join('-'));
  }
  return candidates;
};

export const resolveRetailPrice = (product: ProductComplete): number => {
  const { sku, price } = product.attributes;
  for (const candidateSku of baseSkuCandidates(sku)) {
    const baseProduct = getProductBySku(candidateSku);
    if (baseProduct && baseProduct.attributes.price > price) return baseProduct.attributes.price;
  }

  return price;
};

export type UseBundleSavingsOptions = {
  selections: MaybeRefOrGetter<ProductSelection[]>;
  bundlePrice: MaybeRefOrGetter<number>;
};

export const useBundleSavings = (options: UseBundleSavingsOptions) => {
  const totalRetailPrice = computed(() =>
    toValue(options.selections).reduce(
      (total, selection) => total + resolveRetailPrice(selection.product) * selection.quantity,
      0,
    ),
  );

  const savings = computed(() =>
    Math.max(0, totalRetailPrice.value - toValue(options.bundlePrice)),
  );

  const showSavings = computed(() => toValue(options.bundlePrice) > 0 && savings.value > 0);

  return {
    totalRetailPrice,
    savings,
    showSavings,
  };
};
